var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mainVue',{scopedSlots:_vm._u([{key:"main",fn:function(main){return [_c('imageVue',{attrs:{"data-list":main.data}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }